import { Adslot } from '../modules/adslot-controller/adslot.js';
import { EffectFunction } from './index.js';


/**
 * AdLabel knows several states, which need to be considered for implementation.
 * Allowed: Label is allowed by publisher, expressed either bei local.json or publisher set slotOptions
 *          - when not allowed, render the AdLabel but don't show it, so it can be turned on during runtime.
 * Visibility: Label should
 *          - be visible when AdSlot is filled
 *          - not be visible when AdSlot is empty
 *          - not be visible when AdSlot is filled but used as blocker
 *          - when AdSlot reservesSpaces, hiding the adLabel should not cause CLS
 *
 */

const sdgDisableLabel: string = 'sdgDisableLabel';
/**
 * Effect will show the adLabel if either local.json or Publisher set SlotOptions allows it.
 * If AdLabel is not needed, make sure that it never reserves space on site, via css class "sdgDisableLabel". Class is defined in websiteConfig -> global.json.
 * @constructor
 */
export const ENABLE_AD_LABEL: EffectFunction = ({ advertLabel }: Adslot) => {
    advertLabel.classList.remove(sdgDisableLabel);

    return () => {
        advertLabel.classList.add(sdgDisableLabel);
    };
};
